import LogCannon from '@ace-clublabs/log-cannon';
import { Environments } from '../../../api/endpoints';
import { urlClubCodeMap } from '../../../utils/urlClubCodeMap';
import { MOBILE_APP_QUERY_PARAM, MOBILE_APP_QUERY_PARAM_STORAGE_KEY } from '../../../utils/constants';
import { QueryParamHelper } from '../../../utils/QueryParamHelper';
import { AceIdentityEnv } from '@ace-clublabs/ace-identity';

export const getDotNetLoginRedirectUrl = (env: Environments, clubCode: string): string => {
  const stateCode = urlClubCodeMap[clubCode] || urlClubCodeMap['004'];
  let baseUrl = '';
  if (env === Environments.prod || env === Environments.stage) {
    baseUrl = 'https://apps';
  } else if (env === Environments.uat) {
    baseUrl = 'https://uatmvc';
  } else if (env === Environments.qa) {
    baseUrl = 'https://qamvc';
  } else if (env === Environments.dev) {
    baseUrl = 'https://devmvc';
  } else {
    LogCannon.error('Unable to get LoginRedirectUrl', { clubCode, env });
    throw new Error('Unable to get LoginRedirectUrl');
  }
  return `${baseUrl}.${stateCode}.aaa.com/aceapps/authenticate2/authcodelogin`;
};

export type IdentityUrlType = 'login' | 'logout';

export const getIdentityUrl = (identityUrlType: IdentityUrlType, returnUrl?: string): string => {
  let aceIdentityEnv, identityUrl;
  const host = window.location.host;
  switch (true) {
    case host.includes('appdev2'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      identityUrl = `https://appdev2.ace.aaa.com/enterprise/identity/dev/#/${identityUrlType}`;
      break;
    case host.includes('appqa2'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      identityUrl = `https://appqa2.ace.aaa.com/enterprise/identity/qa/#/${identityUrlType}`;
      break;
    case host.includes('appuat2'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      identityUrl = `https://appuat2.ace.aaa.com/enterprise/identity/uat/#/${identityUrlType}`;
      break;
    case host.includes('appdev'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      identityUrl = `https://appdev1.ace.aaa.com/enterprise/identity/dev/#/${identityUrlType}`;
      break;
    case host.includes('appqa'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      identityUrl = `https://appqa1.ace.aaa.com/enterprise/identity/qa/#/${identityUrlType}`;
      break;
    case host.includes('appuat'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      identityUrl = `https://appuat1.ace.aaa.com/enterprise/identity/uat/#/${identityUrlType}`;
      break;
    case host.includes('account.app.uat'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      identityUrl = `https://appuat1.ace.aaa.com/enterprise/identity/uat/#/${identityUrlType}`;
      break;
    case host.includes('membership.app.ace.aaa.com'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      identityUrl = `https://appdev1.ace.aaa.com/enterprise/identity/dev/#/${identityUrlType}`;
      break;
    case host.includes('app.'):
      aceIdentityEnv = AceIdentityEnv.Prod;
      identityUrl = `https://app.ace.aaa.com/enterprise/identity/#/${identityUrlType}`;
      break;
    default:
      aceIdentityEnv = AceIdentityEnv.NonProd;
      identityUrl = `https://appdev1.ace.aaa.com/enterprise/identity/dev/#/${identityUrlType}`;
  }

  if (returnUrl) {
    identityUrl = identityUrl.split('#').join(`${`?returnUrl=${encodeURIComponent(returnUrl)}`}#`);
  }

  return identityUrl;
};

export const parseMobileAppQueryParamFromUrl = (): string | null => {
  const queryParams = new URLSearchParams(window.location.search);
  const mobileAppQueryParamValue = queryParams?.get(MOBILE_APP_QUERY_PARAM);
  return mobileAppQueryParamValue;
};

export const getIsMobileApp = (): boolean => {
  const urlHasMobileAppQueryParam = QueryParamHelper.getUrlQueryParamValue(MOBILE_APP_QUERY_PARAM) === 'true';
  const hasSavedMobileAppQueryParam =
    QueryParamHelper.getSavedQueryParamValue(MOBILE_APP_QUERY_PARAM, MOBILE_APP_QUERY_PARAM_STORAGE_KEY) === 'true';
  return urlHasMobileAppQueryParam || hasSavedMobileAppQueryParam;
};
